import { ComponentRef, SimpleChanges, isSignal, reflectComponentType } from '@angular/core';

export class WindowHelper {
  public static async getStyleLink(): Promise<string> {
    return new Promise((res, rej) => {
      document.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]').forEach(link => {
        if (link.href.includes('styles.css')) {
          res(link.href);
        }
        if (link.href.includes('styles-')) {
          const match = link.href.match(/styles-([A-Z0-9]+)\.css$/);
          res(match ? link.href : null); // Return the href if found
        }
      });
    });
  }

  public static closeAllWindows(): void {
    const existingWindows = localStorage.getItem('activeWindows');
    if (existingWindows) {
      const activeWindows: Array<string> = JSON.parse(existingWindows);
      activeWindows.forEach(windowName => {
        const reconnectToPopup = window.open('', windowName);
        reconnectToPopup.close();
      });
      localStorage.removeItem('activeWindows');
    }
  }

  public static replicateInputs(properties: Array<string>, controller: any): any {
    const inputs = {};
    properties.forEach(prop => {
      inputs[prop] = WindowHelper.readValue(controller[prop]);
    });
    return inputs;
  }

  public static replicateOutputs(properties: Array<string>, controller: any): any {
    const outputs = {};
    properties.forEach(prop => {
      outputs[prop] = (evt): void => {
        controller[prop].emit(evt);
      };
    });
    return outputs;
  }

  public static replicateChanges(
    properties: Array<string>,
    controller: any,
    componentRef: ComponentRef<unknown>,
    changes: SimpleChanges
  ): void {
    const changedProperties = properties.filter(prop => changes[prop]);
    WindowHelper.setInputs(componentRef, WindowHelper.replicateInputs(changedProperties, controller));
  }

  public static replicateChange(property: string, controller: any, componentRef: ComponentRef<unknown>): void {
    WindowHelper.setInputs(componentRef, WindowHelper.replicateInputs([property], controller));
  }

  /**
   * Alimente les inputs d'un composant créé dynamiquement.
   * Passe par `setInput` car un signal input ne peut pas être affecté depuis l'instance ;
   * Angular déclenche lui-même `ngOnChanges` lors de la détection de changements.
   */
  public static setInputs(componentRef: ComponentRef<unknown>, values: { [key: string]: unknown }): void {
    const declaredInputs = reflectComponentType(componentRef.componentType).inputs.map(input => input.templateName);
    Object.keys(values)
      .filter(key => declaredInputs.includes(key))
      .forEach(key => componentRef.setInput(key, values[key]));
    componentRef.changeDetectorRef.detectChanges();
  }

  private static readValue(value: unknown): unknown {
    return isSignal(value) ? value() : value;
  }
}
